import React from 'react';
import ReactDOM from 'react-dom';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts); //init module
import theme from './highcharts_theme';

export default class StaticChart extends React.Component {
  constructor(props) {
    super(props);
  }

  afterChartCreated(chart) {
    setTimeout(function() {
      chart.reflow();
    }, 50);
  }

  render() {
    const options = this.props.options;
    Highcharts.theme = theme;
    Highcharts.setOptions(Highcharts.theme);

    return (
      <React.Fragment>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          callback={this.afterChartCreated} />
      </React.Fragment>
    );

  }
}
